import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import user from "./slices/user-slice";
import question from "./slices/question-slice";
import files from "./slices/file-slice";

// The whitelist only filters writes; discard legacy overrides on rehydration too.
const persistConfig = { key: "root", storage, whitelist: [], migrate: async () => undefined };

const persistedUserSlice = persistReducer(persistConfig, user);

const store = configureStore({
  reducer: {
    user: persistedUserSlice, question, files
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'qna/post/fulfilled'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export const persistor = persistStore(store);
export default store;
